module.exports = __webpack_public_path__ + "img/location-tip.fa14cef1.jpg";